import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getCareTeamRows } from "./care-team-rows";

export const metadata = {
  tableType: "CareTeam",
  displayName: "Care Team",
  getRows: (bundle: FhirBundleSdk) => getCareTeamRows({ bundle }),
  getSearchableText: (row: Record<string, unknown>) => {
    // Include fields visible in the table for search indexing
    const searchableFields = [
      "name",
      "specialty",
      "phone",
      "email",
      "address",
      "mostRecentAppointment",
    ];

    const rowValues = searchableFields
      .map(key => String(row[key] ?? ""))
      .filter(val => val && val !== "-")
      .join(" ");

    return rowValues.toLowerCase();
  },
};
